"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createPerformanceObserver = require("../utilities/createPerformanceObserver");

var _performance = require("../utilities/performance");

var _getFirstHiddenTime = _interopRequireDefault(require("../utilities/getFirstHiddenTime"));

/**
 * A plugin responsible for measuring first input delay.
 *
 * This plugin adds the following parameters to the beacon:
 *
 * - `firstInputDelay`: the time from when a user first interacts with your site
 *   (i.e. when they click a link, tap on a button) to the time when the browser
 *   is actually able to respond to that interaction.
 *
 * @see https://web.dev/fid/
 */
var createEventTimingPlugin = function createEventTimingPlugin() {
  return function (_ref) {
    var addVariable = _ref.addVariable,
        sendBeacon = _ref.sendBeacon;
    var observer;

    var handlePerformanceEntry = function handlePerformanceEntry(entry) {
      // Only report FID if the page wasn't hidden prior to the entry being
      // dispatched. This typically happens when a page is loaded in a
      // background tab.
      if (entry.startTime < (0, _getFirstHiddenTime.default)()) {
        addVariable('firstInputDelay', entry.processingStart - entry.startTime, true);
      }

      if (observer != null) {
        observer.disconnect();
      }

      sendBeacon();
    };

    try {
      observer = (0, _createPerformanceObserver.createPerformanceObserver)(_performance.EntryType.FIRST_INPUT, handlePerformanceEntry);
    } catch (error) {// Do nothing
    }
  };
};

var _default = createEventTimingPlugin;
exports.default = _default;